import { Capacitor } from "@capacitor/core";
import { initializeWebPush } from "./webPush";
import { initializeNativePush } from "./nativePush";

export const initializePushNotifications = async () => {
    const platform = Capacitor.getPlatform();

    console.log("🔍 Current platform:", platform);

    if (platform === "web") {
        await initializeWebPush();
    } else {
        await initializeNativePush();
    }
};
